import { createReducer } from '@reduxjs/toolkit';
import { DeepWritable } from 'ts-essentials';

import { UseAppSearchParamsResult } from 'utils/url/useAppSearchParams';

import { dashboardActions } from './dashboard.actions';

export type DashboardState = {
  lastSearchParams?: UseAppSearchParamsResult<'/dashboard/queues'>['params'];
};

export const initialState: DashboardState = {
  lastSearchParams: undefined,
};

export const dashboardReducer = createReducer(initialState, (builder) =>
  builder.addCase(
    dashboardActions.setLastSearchParams,
    (state, { payload }) => {
      state.lastSearchParams = payload.params as DeepWritable<
        typeof payload.params
      >;
    },
  ),
);
